import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import styles from './deleteConfirmation.module.sass';
import { DeleteConfirmationProps } from '../../../types/base';

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  open,
  baseTitle,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className={styles.dialog}
      sx={{ '& .MuiPaper-root': { backgroundColor: '#8586A5' } }}
    >
      <DialogTitle>База будет удалена безвозвратно</DialogTitle>
      <DialogContent>
        Вы уверены, что хотите удалить базу "{baseTitle}"?
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Отмена</Button>
        <Button onClick={onConfirm} color="error">
          Удалить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmation;
